/**
 * Reports View
 */
export default () => ({
  path : '/cocreation',
  title: 'Co Creación',

  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const Cocreation = require('./containers/CocreationViewContainer').default
      const ToolbarFilters = require('../../components/ToolbarFilters').default
      const AlertStatusBar = require('../../components/AlertsStatusBar').default
      cb(null, {
        content: Cocreation,
        statusBar: AlertStatusBar,
        toolbarFilters: ToolbarFilters
      })
    }, 'reports')
  },
})



// WEBPACK FOOTER //
// ./src/routes/Cocreation/index.js